<template>
  <avz-property-groups />
</template>

<script>
import PropertyGroups from '@/components/PropertyGroups'

export default {
  components: {
    'avz-property-groups': PropertyGroups
  }
}
</script>
